import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Share2, Eye } from 'lucide-react';
import SEO from './SEO';
import PageHeader from './PageHeader';

const ProFeatures = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem('tweeporter_user_tier', 'pro');
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      title: 'Visual Editor',
      description: 'Build interactive stories with a powerful node-based visual editor. See your story structure at a glance.',
      icon: Eye,
      action: () => navigate('/visual-editor?starter=true'),
      color: 'from-purple-500 to-indigo-600'
    },
    {
      title: 'Visual Story Planner',
      description: 'Plan complex narratives with chapters, sections, and branching paths before diving into details.',
      icon: Sparkles,
      action: () => navigate('/visual-story-planner'),
      color: 'from-indigo-500 to-purple-600'
    },
    {
      title: 'Shared Story (Beta)',
      description: 'Create live interactive sessions where multiple users can experience your story together.',
      icon: Share2,
      action: () => navigate('/compiler'),
      color: 'from-violet-500 to-purple-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-slate-900">
      <SEO title="PRO Features - TweePorter" />
      
      <PageHeader lightText={true} />

      <div className="container mx-auto px-4 py-12">
        {/* Page headline */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-purple-600 text-white text-sm font-bold rounded-full mb-4">
            PRO
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Professional Tools
          </h1>
          <p className="text-xl text-purple-200 max-w-2xl mx-auto">
            Advanced features for serious storytellers and content creators.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all cursor-pointer group"
              onClick={feature.action}
            >
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <feature.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
              <p className="text-purple-200 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProFeatures;
